import { SocialAuthVerificationPage } from "./VerifySocialAuth";
export default SocialAuthVerificationPage;
